/*
  Ported off jQuery. The two effects this file used - slideToggle() on the nav
  drawer and animate({scrollTop}) - are reimplemented below with the same
  durations and easing jQuery used (400ms / 100ms, "swing"), because
  assets/theme.css documents the drawer's open/close animation as being driven
  from here rather than by a CSS class.
*/
(function () {
  'use strict';

  var SLIDE_DURATION = 400; // jQuery's default for slideToggle()
  var SCROLL_DURATION = 100; // preserved from the previous animate({...}, 100)

  // jQuery's default easing.
  function swing(progress) {
    return 0.5 - Math.cos(progress * Math.PI) / 2;
  }

  // Returns a cancel function for the caller to hold onto.
  function animate(duration, onStep, onDone) {
    var start = null;
    var handle;

    function frame(now) {
      if (start === null) start = now;
      var progress = duration > 0 ? Math.min((now - start) / duration, 1) : 1;
      onStep(swing(progress));
      if (progress < 1) {
        handle = requestAnimationFrame(frame);
      } else if (onDone) {
        onDone();
      }
    }

    handle = requestAnimationFrame(frame);
    return function cancel() {
      cancelAnimationFrame(handle);
    };
  }

  /*
    slideToggle(): animates height between 0 and the element's natural height
    with overflow clipped, then clears the inline height/overflow so the
    stylesheet takes over again - the drawer relies on its own max-height and
    overflow-y rules below 1200px, which is also why the open height is measured
    while the element is visible: offsetHeight already accounts for that clamp.

    A toggle arriving mid-animation cancels the running one and reverses from the
    current height instead of being dropped, so double-clicking the hamburger
    cannot leave the drawer stuck half-open.
  */
  function slideToggle(el) {
    var wasAnimating = typeof el._slideCancel === 'function';
    if (wasAnimating) {
      el._slideCancel();
      el._slideCancel = null;
    }

    var opening = wasAnimating
      ? !el._slideOpening
      : window.getComputedStyle(el).display === 'none';
    var from = wasAnimating ? el.offsetHeight : 0;
    var to;

    el._slideOpening = opening;
    el.style.overflow = 'hidden';

    if (opening) {
      el.style.display = 'block';
      // Measure the height the stylesheet gives it before animating up to it.
      el.style.removeProperty('height');
      to = el.offsetHeight;
    } else {
      if (!wasAnimating) from = el.offsetHeight;
      to = 0;
    }

    el.style.height = from + 'px';

    el._slideCancel = animate(
      SLIDE_DURATION,
      function (eased) {
        el.style.height = from + (to - from) * eased + 'px';
      },
      function () {
        el._slideCancel = null;
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        if (!opening) el.style.display = 'none';
      }
    );
  }

  /*
    Below 1200px the drawer is a full-screen sheet, and with the light header
    a side panel on desktop too (assets/mobile-menu.css), so instead of
    growing in height it slides in from the left edge - where
    the hamburger is, on /ar too - and back out to the left on close. The
    slide is a CSS transition on transform (.mobile-menu--open, see
    assets/mobile-menu.css), which runs on the compositor and stays smooth on
    phones; a toggle mid-slide simply reverses it from where it is.
  */
  function slideSheetToggle(el) {
    clearTimeout(el._sheetHideTimer);
    var opening = !el.classList.contains('mobile-menu--open') || window.getComputedStyle(el).display === 'none';

    if (opening) {
      // Other code (assets/custom.js) can hide it with display:none directly,
      // leaving the class behind - start from the closed position each time.
      el.classList.remove('mobile-menu--open');
      // Every open starts from the default: Shop open, the other groups closed
      // (an accordion - snippets/nav-drawer.liquid, assets/mobile-menu.js).
      el.querySelectorAll('details.mobile-menu__group').forEach(function (group) {
        group.querySelectorAll('.mobile-menu__sublinks').forEach(function (links) {
          if (links.getAnimations) links.getAnimations().forEach(function (animation) { animation.cancel(); });
        });
        group.classList.remove('mobile-menu__group--closing');
        group.open = Boolean(group.closest('.mobile-menu__shop'));
      });
      el.style.display = 'block';
      void el.offsetWidth; // commit the off-screen position before sliding in
      el.classList.add('mobile-menu--open');
      return true;
    }

    el.classList.remove('mobile-menu--open');

    var duration = parseFloat(window.getComputedStyle(el).transitionDuration) * 1000 || 0;
    function hide() {
      el.removeEventListener('transitionend', onEnd);
      if (!el.classList.contains('mobile-menu--open')) el.style.display = 'none';
    }
    function onEnd(event) {
      if (event.target === el && event.propertyName === 'transform') hide();
    }
    el.addEventListener('transitionend', onEnd);
    // Fallback in case transitionend never fires (reduced motion, tab hidden).
    el._sheetHideTimer = setTimeout(hide, duration + 50);
    return false;
  }

  // The sliding drawer: always below 1200px; on desktop only with the light
  // header, whose MENU button opens it as a side panel (assets/mobile-menu.css).
  function usesSheet() {
    return document.documentElement.clientWidth < 1200 || Boolean(document.querySelector('#SiteHeader.site-header--refined'));
  }

  function animateScrollTop(target, duration) {
    var from = window.pageYOffset;
    if (from === target) return;
    animate(duration, function (eased) {
      window.scrollTo(0, from + (target - from) * eased);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.dev_open_custom_drawer');
    if (!trigger) return;

    var drawer = document.getElementById('nav-drawer');
    if (drawer && usesSheet()) {
      var opened = slideSheetToggle(drawer);
      // Set, not toggled, so the scroll lock can't drift out of step with the
      // drawer if something else (assets/custom.js) hid it meanwhile.
      document.querySelectorAll('.dev_make_overflow_hidden_on_header_open').forEach(function (el) {
        el.classList.toggle('overflow-y-hidden', opened);
      });
      return;
    }

    if (drawer) slideToggle(drawer);

    document.querySelectorAll('.dev_make_overflow_hidden_on_header_open').forEach(function (el) {
      el.classList.toggle('overflow-y-hidden');
    });

    // The 34px scroll tucked the announcement bar away for the old drawer,
    // which hung under the header. Below 1200px the menu is now a full-screen
    // sheet (assets/mobile-menu.css), and that scroll counted as "scrolling
    // down" for updateHeaderStyles() below, which hid the header (top: -90px)
    // - and nothing scrolled back up on close, so the header stayed gone.
    if (document.documentElement.clientWidth >= 1200) {
      animateScrollTop(34, SCROLL_DURATION);
    }
  });

  // Escape closes the sliding drawer (mobile sheet / light header's desktop panel).
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var drawer = document.getElementById('nav-drawer');
    if (!drawer || !drawer.classList.contains('mobile-menu--open') || !usesSheet()) return;
    slideSheetToggle(drawer);
    document.querySelectorAll('.dev_make_overflow_hidden_on_header_open').forEach(function (el) {
      el.classList.remove('overflow-y-hidden');
    });
  });

  /*
    Back/forward cache: tapping a menu link and pressing Back can restore this
    page exactly as it was left - drawer open, page scroll-locked - so the
    page looked frozen until the menu was closed. Restored pages start with it
    closed (instantly, no slide).
  */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var drawer = document.getElementById('nav-drawer');
    if (drawer) {
      clearTimeout(drawer._sheetHideTimer);
      drawer.classList.remove('mobile-menu--open');
      drawer.style.display = 'none';
    }
    document.querySelectorAll('.dev_make_overflow_hidden_on_header_open').forEach(function (el) {
      el.classList.remove('overflow-y-hidden');
    });
  });

  var lastScrollTop = 0;
  var header = document.querySelector('header[data-section-id]');

  function updateHeaderStyles() {
    if (!header) return;

    var currentScrollTop = window.pageYOffset;
    // documentElement.clientWidth, not innerWidth: this is what $(window).width()
    // returned, and it excludes the scrollbar - innerWidth includes it, which
    // would shift the 768px branch on desktop.
    var windowWidth = document.documentElement.clientWidth;
    var scrollingDown = currentScrollTop > lastScrollTop;

    if (windowWidth > 768) {
      header.style.top = scrollingDown ? '-280px' : '0';
      header.style.borderColor = '#EDEDED';
    } else {
      header.style.top = scrollingDown ? '-90px' : '0';
      header.style.borderColor = '#CCCCCC';
      header.classList.toggle('header_stuck', !scrollingDown);
    }

    lastScrollTop = currentScrollTop;
  }

  // passive: the handler only reads scroll position, it never preventDefault()s.
  window.addEventListener('scroll', updateHeaderStyles, { passive: true });

  var eleLang = document.documentElement.getAttribute('lang');
  document.querySelectorAll('#HeaderLanguageList a').forEach(function (link) {
    link.style.fontWeight = eleLang === link.getAttribute('lang') ? '900' : 'normal';
  });

  /*
    CRO ticket ("Main Site Navigation"): top-level nav items like "SHOP" open
    their mega-menu on hover (assets/theme.js's hover-disclosure component),
    but the link itself wasn't reliably navigating on click - moving the
    mouse onto the trigger starts the dropdown opening/reflowing immediately
    (snippets/nav-item.liquid's [data-hover-disclosure-toggle] wrapper), so by
    the time mouseup fires the browser's hit-test can land somewhere other
    than the link and no click event - therefore no navigation - ever fires.
    No preventDefault() anywhere causes this; verified live that it's the
    reflow itself swallowing the click.

    Binding to mousedown instead sidesteps that: it always fires on whatever
    is under the cursor at press time, before that reflow has a chance to
    happen, and it doesn't touch hover behaviour at all - the dropdown still
    opens on hover exactly as before.
  */
  document.querySelectorAll('[data-hover-disclosure-toggle] > [data-top-link]').forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    link.addEventListener('mousedown', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      window.location.href = href;
    });
  });
})();
